var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3332 16.1004V18.6004C20.3341 18.8325 20.2866 19.0622 20.1936 19.2749C20.1006 19.4875 19.9643 19.6784 19.7933 19.8353C19.6222 19.9922 19.4203 20.1116 19.2005 20.186C18.9806 20.2603 18.7477 20.288 18.5165 20.2671C15.9522 19.9884 13.489 19.1122 11.3249 17.7087C9.31139 16.4293 7.60431 14.7222 6.32486 12.7087C4.91651 10.5347 4.04007 8.05957 3.76653 5.48374C3.7457 5.2533 3.77309 5.02104 3.84695 4.80176C3.9208 4.58248 4.03951 4.38098 4.1955 4.21009C4.3515 4.0392 4.54137 3.90266 4.75302 3.80917C4.96468 3.71569 5.19348 3.66729 5.42486 3.66707H7.92486C8.32928 3.66309 8.72136 3.80631 9.028 4.07002C9.33464 4.33373 9.53493 4.69995 9.59153 5.10041C9.69705 5.90046 9.89274 6.68601 10.1749 7.44207C10.287 7.74034 10.3112 8.0645 10.2448 8.37614C10.1783 8.68778 10.0239 8.97383 9.79986 9.20041L8.74153 10.2587C9.92783 12.345 11.6552 14.0724 13.7415 15.2587L14.7999 14.2004C15.0264 13.9764 15.3125 13.8219 15.6241 13.7555C15.9358 13.689 16.2599 13.7133 16.5582 13.8254C17.3143 14.1075 18.0998 14.3032 18.8999 14.4087C19.3047 14.4658 19.6744 14.6697 19.9386 14.9817C20.2029 15.2936 20.3433 15.6917 20.3332 16.1004Z",
    stroke: "#22232C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone_icon.f9fb8164669f7833ac74519d4bdd912b.svg";
export { ForwardRef as ReactComponent };